import * as React from 'react';
import Select from './Select.jsx';
import { ajaxFetcherGet } from '../../../../fetchers'

export default function SelectAccommodations(props) {
	let {
		parentFunction,
		selectedItems
	} = props;

	const [isLoading, setIsLoading] = React.useState(true);
	const [hotels, setHotels] = React.useState([]);

	React.useEffect(() => {
		ajaxFetcherGet({	
			url: ENV.base_lang_url + "myspace/providers//ajaxGetter/get_all_hotels"
		}).then((res) => {
			setHotels(res)
			setIsLoading(false)
		})
	}, [])

	return (
		<Select
			parentFunction={parentFunction}
			slug={'accommodations'}
			label={'accommodations'.trad()}
			placeHolder={''}
			items={hotels}
			selectedItems={selectedItems}
			autoTrad={false}
			multiple={true}
			limitTags={2}
			isLoading={isLoading}
		/>
	);
}